/**
 * Header loop: attach the <video> only when motion and data are allowed.
 * Reduced-motion and save-data both keep the poster <img> only.
 */
export function shouldAttachHeaderClip({ reducedMotion, saveData }) {
  return !reducedMotion && !saveData;
}

/** Media type permitted by preferences; playback still requires a user action. */
export function headerMediaTag({ reducedMotion, saveData }) {
  return shouldAttachHeaderClip({ reducedMotion, saveData }) ? 'video' : 'img';
}
